import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, PHOTO_BASE_URL_Admin } from '../../Api/config';
import GPTEDIcon from '../../Assets/icon/GPTEDIcon.png';
import tenderNotFoundImage from '../../Assets/images/tenderNotFoundImage.png';
import { useNavigate } from 'react-router-dom';
import { Button, Pagination } from 'antd';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { Spinner } from "flowbite-react";
import { ChevronDown } from "lucide-react"; // Import down arrow icon
const TenderTabs = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [tendersData, setTendersData] = useState([[], [], [], []]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 10;

  const tabs = [
    'Free Tenders',
    'Popular Tenders',
    'Hot Tenders',
    "Hot Int'l Tender",
  ];
  const tabsChanges = ['free', 'popular', 'hot', 'corrigendum', 'int_popular'];

  useEffect(() => {
    setLoading(true);
    const fetchTendersData = async () => {
      try {
        let url;
        if (activeTab === 0) {
          url = `${API_BASE_URL}/user/visitor/free?limit=${cardsPerPage}&skip=${(currentPage - 1) * cardsPerPage}`;
        } else {
          url = `${API_BASE_URL}/user/visitor?type=${tabsChanges[activeTab]}&limit=${cardsPerPage}&skip=${(currentPage - 1) * cardsPerPage}`;
        }
        const response = await axios.get(url);
        const filteredTenders = response.data?.data?.filter(
          tender => tender.status === 1 && tender.permission === 'publish'
        );
        setTendersData(prev => {
          const updated = [...prev];
          updated[activeTab] = filteredTenders;
          return updated;
        });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching tenders:', error);
        setLoading(false);
      }
    };
    fetchTendersData();
  }, [activeTab, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const itemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <a className='flex items-center gap-1'><FaAngleLeft /> Back</a>;
    }
    if (type === 'next') {
      return <a className='flex items-center gap-1'>Next <FaAngleRight /></a>;
    }
    return originalElement;
  };

  const handleCardClick = tender_id => {
    navigate('/limitedTenderView', { state: { tender_id } });
    window.scrollTo(0, 0);
  };



  return (
    <div className="w-full md:px-7 px-2 py-6 lg:px-20 lg:py-10 mt-28">
      <div className="flex items-center justify-center md:mb-10 mb-4">
        <div className="text-black md:p-2 p-1 rounded md:text-sm text-[10px] flex justify-center gap-2 md:gap-4 pb-2 md:mb-5 mb-2">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`px-2 md:px-5 py-1 rounded transition-all duration-300 flex  items-center gap-1 ${activeTab === index
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-300 text-black'
                }`}
              onClick={() => {
                setActiveTab(index);
                setCurrentPage(1);
              }}
            >
              {tab}
              {activeTab === index && <ChevronDown size={16} />}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="w-full flex flex-col items-center justify-center py-10">
          <img
            src={tenderNotFoundImage}
            alt="No Tenders Found"
            className="w-80 h-80 object-contain"
          />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-4 gap-7 2xl-grid-cols-6">
            {tendersData[activeTab].length === 0 ? (
              <div className="col-span-full text-center">
                <img
                  src={tenderNotFoundImage}
                  alt="No tenders found"
                  className="w-60 h-52 mx-auto"
                />
              </div>
            ) : (
              tendersData[activeTab].map(tender => (
                <div
                  key={tender.id}
                  onClick={() => {
                    if (activeTab === 0) {
                      navigate(`/pdf-viewer/${tender.id}`);
                      window.scrollTo(0, 0);
                    } else {
                      handleCardClick(tender.tender_id);
                    }
                  }}
                  className="rounded-md shadow-lg border cursor-pointer"
                >
                  <div>
                    <img
                      src={
                        tender.company_logo
                          ? `${PHOTO_BASE_URL_Admin}${tender.company_logo}`
                          : GPTEDIcon
                      }
                      alt="Company Logo"
                      className="h-32 w-full object-cover rounded-t-lg"
                    />
                    <div className="p-4">
                      <h3 className="text-sm font-bold text-gray-800 mb-2 relative group">

                        <span className="line-clamp-2"> {tender.name}</span>


                        {/* Hover to show full name */}
                        <span className="absolute hidden group-hover:block bg-gray-600 text-white text-sm rounded-lg shadow-lg p-2 z-20 bottom-full mt-2  left-1/2 transform -translate-x-1/2 w-full mx-3">
                          {tender.name}
                        </span>
                      </h3>

                      <p className="text-gray-600 text-xs">
                        <strong>Tender ID:</strong> {tender.tender_id}
                      </p>
                      <p className="text-gray-600 text-xs mb-2">
                        <strong>Published On:</strong> {tender.publish_on}
                      </p>
                      {/* View PDF Button */}
                      {activeTab === 0 && tender.file_upload && (
                        <div className="mt-auto">
                          <button
                            // onClick={() => {
                            //   navigate(`/pdf-viewer/${tender.id}`);
                            //   window.scrollTo(0, 0);
                            // }}
                            className="w-full mt-auto bg-blue-600 text-white px-3 py-2 text-xs rounded-md shadow-md hover:bg-blue-700 transition-all"
                          >
                            📄 View PDF
                          </button>
                        </div>
                      )}
                      {activeTab !== 0 && (
                        <div className="mt-auto">
                          <button
                            // onClick={() => handleCardClick(tender.tender_id)}
                            className="w-full mt-auto bg-blue-600 text-white px-3 py-2 text-xs rounded-md shadow-md hover:bg-blue-700 transition-all"
                          // className="w-full border border-gray-300 px-2 py-2 text-xs rounded-md shadow-sm bg-white text-black hover:text-blue-600 hover:border-blue-600"
                          >
                            View Details
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          <div className="flex justify-end mt-6">
            <Pagination
              current={currentPage}
              total={tendersData[activeTab].length * cardsPerPage}
              pageSize={cardsPerPage}
              onChange={handlePageChange}
              itemRender={itemRender}
              className="custom-pagination"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default TenderTabs;
